<template>
  <div class="container" v-loading="loading">
    <el-row>
      <el-col :span="12">
        <el-form :model="goods" :rules="goodsValidator" ref="goods" label-width="100px">
          <el-form-item label="产品名称" prop="name">
            <el-input v-model="goods.name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品描述" prop="desc">
           <el-input type="textarea" v-model="goods.desc" placeholder="描述一下商品吧~~"
            :autosize="{minRows: 10, maxRows: 20}"></el-input>
          </el-form-item>
          <el-form-item label="产品图片" prop="pictures">
            <el-upload
            action=""
            :http-request="handleUpload"
            list-type="picture-card"
            multiple
            accept="image/*"
            :on-remove="handleUploadRemove"
            :file-list="goods.pictures">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="店内分类" prop="tagId">
            <el-radio-group v-model="goods.tagId">
              <el-radio v-for="(tag, index) in tags" :key="tag.id" :label="tag.id">{{ tag.name }}</el-radio>
            </el-radio-group>
            <br>
            <router-link :to="'/shop/' + shopId + '/tags'">
              <el-button type="primary" size="small">管理商品分类</el-button>
            </router-link>
          </el-form-item>
          <el-form-item label="产品价格" prop="price">
            <el-input type="number" v-model.number="goods.price" placeholder="请输入商品价格"></el-input>
          </el-form-item>
          <el-form-item label="产品规格类型" label-width="120px">
            <el-radio-group v-model="goods.type">
              <el-radio :label=1>单规格</el-radio>
              <el-radio :label=2>多规格</el-radio>
              <el-radio :label=3>复杂规格</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="goods.type === 2" class="specs-wrapper">
            <div class="specs-item" v-for="(spec, index) in goods.specs" :key="spec.key">
              <i class="el-icon-delete delete-item" @click="deleteSameGoods(index)"></i>
              <el-form-item label="规格" label-width="60px"
                :prop="'specs[' + index + '].name'"
                :rules="{ required:true, message: '请输入规格的名称', trigger: 'blur' }">
                <el-input v-model="spec.name" placeholder="请填写规格名称"></el-input>
              </el-form-item>
              <el-form-item label="价格" label-width="60px" :prop="'specs[' + index + '].price'"
                :rules="[{ required: true, message: '请输入规格的价格'},
                { type: 'float', message: '价格格式不正确', trigger: 'change' }]">
                <el-input type="number" v-model.number="spec.price" placeholder="请填写规格价格"></el-input>
              </el-form-item>
            </div>
          </div>
          <div v-if="goods.type === 3" class="specs-wrapper">
            <div class="specs-item" v-for="(spec, index) in goods.specs" :key="spec.key">
              <i class="el-icon-delete" @click="deleteSpecs(index)"></i>
              <div v-for="(value, name) in spec">
                <el-form-item v-if="name === 'Name'" label="规格" label-width="120px"
                              :rules="{ required:true, message: '请输入规格的名称', trigger: 'blur' }">
                  <el-input v-model="spec.Name" placeholder="请填写规格名称"></el-input>
                </el-form-item>
                <el-form-item v-if="name === 'range'" label="可选个数" label-width="120px"
                              :rules="{ required:true, message: '请输入可选个数', trigger: 'blur' }">
                  <el-input type="number" v-model.number="spec.range" placeholder="请填写可选个数"></el-input>
                </el-form-item>
                <el-form-item v-if="name === 'required'" label="是否必须" label-width="120px">
                  <el-radio-group v-model="spec.required">
                    <el-radio label="required">必须</el-radio>
                    <el-radio label="optional">可选</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-if="name === 'type'" label="显示方式" label-width="120px">
                  <el-radio-group v-model="spec.type">
                    <el-radio label="radio">Radio(单选)</el-radio>
                    <el-radio label="checkbox">Checkbox(多选)</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-if="name === 'maximum'" label="最多可选" label-width="120px"
                              :rules="{ required:true, message: '请输入最多可选', trigger: 'blur' }">
                  <el-input type="number" v-model.number="spec.maximum" placeholder="请填写最多可选"></el-input>
                </el-form-item>
                <el-form-item v-if="name === 'minimum'" label="最少可选" label-width="120px"
                              :rules="{ required:true, message: '请输入最少可选', trigger: 'blur' }">
                  <el-input type="number" v-model.number="spec.minimum" placeholder="请填写最少可选"></el-input>
                </el-form-item>
                <el-form-item v-if="name === 'maximumEach'" label="最多每个可选" label-width="120px"
                              :rules="{ required:true, message: '请输入最多每个可选', trigger: 'blur' }">
                  <el-input type="number" v-model.number="spec.maximumEach" placeholder="请填写最多每个可选"></el-input>
                </el-form-item>
                <div v-if="name === 'options'" v-for="(option, optionIndex) in value" :key="optionIndex">
                  <div class="delete-option">
                    <i class="el-icon-delete" @click="deleteOptions(index, optionIndex)"></i>
                    <div v-for="(optionItemValue, optionItemName) in option">
                      <el-form-item v-if="optionItemName === 'spec'" label="选项名称" label-width="100px"
                                    :rules="{ required:true, message: '请输入规格的名称', trigger: 'blur' }">
                        <el-input v-model="option.spec" placeholder="请填写选项名称"></el-input>
                      </el-form-item>
                      <el-form-item v-if="optionItemName === 'price'" label="选项加价" label-width="100px"
                                    :rules="[{ required: true, message: '请输入规格的价格'},
                                    { type: 'float', message: '价格格式不正确', trigger: 'change' }]">
                        <el-input type="number" v-model.number="option.price" placeholder="请填写选项加价"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <el-form-item v-if="name === 'options'">
                  <el-button icon="plus" size="small" @click="addNewOptions(index)">添加新的选项</el-button>
                </el-form-item>
              </div>
            </div>
          </div>
          <el-form-item v-if="goods.type > 1">
            <el-button icon="plus" size="small" @click="addNewSpec">添加新的规格</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('goods')">{{ this.goodsid ? '更新商品' : '添加商品' }}</el-button>
            <el-button @click="reset('goods')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getPresignedUrl, deleteGoodsSpec } from '@/store/api.js'
import { ossurl } from '@/utils/tools.js'
import store from '@/store'
import axios from 'axios'
import VueUeditor from '@/components/vue-ueditor'

export default {
  name: 'shop-goods-add',
  components: {
    VueUeditor
  },
  data () {
    return {
      loading: true,
      goods: {
        name: '',
        type: 1,
        desc: '',
        tagId: '',
        pictures: [],
        imgs: [],
        price: '',
        imgsTemp: [],
        stock: '',
        specs: []
      },
      goodsValidator: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    tags () {
      return this.$store.state.shop.tags || []
    },
    shopId () {
      return this.$store.state.shop.shopId
    },
    goodsid () {
      return this.$route.query.goodsid
    }
  },
  watch: {
    '$route' (to) {
      this.loading = true
      this.$store.dispatch('shop/fetchGoodsDetail', this.goodsid)
      .then((res) => {
        this.goods.name = res.name
        this.goods.desc = res.description || ''
        this.goods.tagId = res.tag_id || ''
        this.goods.pictures = res.imgs || []
        this.goods.price = res.price || ''
        this.goods.stock = res.stock
        this.goods.specs = res.spec || []
        this.goods.type = res.type || 1
        this.loading = false
      })
    }
  },
  methods: {
    descChanged (content) {
      this.goods.desc = [{type: 3, text: content}]
    },
    // selectDetailImage () {
    //   var picker = document.querySelector('.detail-image-picker .el-upload')
    //   picker.click()
    // },
    addDetailImage (fileUrl) {
      this.goods.desc.push({type: 2, text: fileUrl})
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            shop_id: this.shopId,
            name: this.goods.name,
            type: this.goods.type,
            description: this.goods.desc,
            tag_id: this.goods.tagId > 0 ? this.goods.tagId : 0,
            imgs: JSON.stringify(this.goods.imgs),
            price: this.goods.price
          }
          if (this.goods.specs.length) {
            params.specs = JSON.stringify(this.goods.specs)
          }
          this.loading = true
          if (!this.goodsid) {
            this.$store.dispatch('shop/addGoods', params).then((res) => {
              this.loading = false
              if (!res.errcode) {
                this.$message('商品信息已添加')
                this.$router.push({path: '/shop/' + this.shopId + '/goods/list'})
              } else {
                this.$message('商品信息添加失败：' + res.errmsg)
              }
            }).catch(() => {
              this.loading = false
            })
          } else {
            params.product_id = this.goodsid
            this.$store.dispatch('shop/updateGoods', params).then((res) => {
              this.loading = false
              if (!res.errcode) {
                this.$message('商品信息已更新')
                this.$router.push({path: '/shop/' + this.shopId + '/goods/list'})
              } else {
                this.$message('商品信息更新失败：' + res.errmsg)
              }
            }).catch(() => {
              this.loading = false
            })
          }
        }
      })
    },
    reset () {
      this.goods.name = ''
      this.goods.desc = ''
      this.goods.sort = ''
      this.goods.price = ''
      this.goods.specs = []
    },
    addNewSpec () {
      let newSpec = {}
      if (this.goods.type === 3) {
        newSpec = {
          Name: '',
          maximum: 1,
          minimum: 1,
          maximumEach: 1,
          range: 1,
          required: 'required',
          type: 'radio',
          options: [
            {
              spec: '',
              price: 0
            }
          ]
        }
      } else {
        newSpec = {
          name: '',
          price: 0,
          key: Date.now()
        }
      }
      this.goods.specs.push(newSpec)
    },
    addNewOptions (index) {
      const newOption = {
        spec: '',
        price: 0
      }
      this.goods.specs[index].options.push(newOption)
    },
    deleteSpecs (index) {
      this.goods.specs.splice(index, 1)
    },
    deleteOptions (index, optionIndex) {
      this.goods.specs[index].options.splice(optionIndex, 1)
    },
    deleteSameGoods (index) {
      let productId = this.goodsid
      let specId = this.goods.specs[index].id
      this.goods.specs.splice(index, 1)

      return deleteGoodsSpec(productId, specId).then(resp => {
        if (resp.errcode === 0) {
          this.$message('删除成功')
        }
      })
    },
    async handleUpload (params) {
      try {
        const userId = store.state.userInfo ? store.state.userInfo.id : 'admin'
        const fileName = Date.now() + '-' + params.file.name
        const presigned = await getPresignedUrl(userId, 'image', fileName, params.file.type || 'image/jpeg')
        const formdata = new FormData()
        Object.keys(presigned.fields).forEach(key => {
          formdata.append(key, presigned.fields[key])
        })
        formdata.append('file', params.file)
        await axios.post(presigned.url, formdata)
        const fileUrl = 'https://woohelps.sgp1.digitaloceanspaces.com/' + presigned.fields.key
        this.$message('图片上传成功')
        this.goods.imgsTemp.push({'uid': params.file.uid, 'url': fileUrl})
        this.goods.imgs.push(fileUrl)
      } catch (err) {
        this.$message('图片上传失败')
      }
    },
    handleUploadRemove (file, fileList) {
      let index = -1
      index = this.goods.imgsTemp.findIndex((item) => {
        if (item.uid) {
          return item.uid === file.raw.uid
        } else {
          return item === file.url.split('.com/')[1]
        }
      })
      this.goods.imgsTemp.splice(index, 1)
      this.goods.imgs.splice(index, 1)
    }
  },
  mounted () {
    this.$store.commit('shop/setShopId', this.$route.params.sid)
    if (this.goodsid) {
      Promise.all([
        this.$store.dispatch('shop/fetchGoodsDetail', this.goodsid),
        this.$store.dispatch('shop/fetchTags', this.shopId)
      ])
      .then((result) => {
        let res = result[0]
        this.goods.name = res.name
        this.goods.desc = res.description || ''
        this.goods.tagId = res.tag_id || ''
        this.goods.imgs = JSON.parse(JSON.stringify(res.imgs))
        this.goods.imgsTemp = JSON.parse(JSON.stringify(res.imgs))
        res.imgs.map((img) => {
          this.goods.pictures.push({ url: ossurl(img) })
        }) || []
        this.goods.price = res.price || ''
        this.goods.stock = res.stock
        this.goods.specs = res.spec || []
        this.goods.type = res.type || 1
        this.loading = false
      })
    } else {
      this.$store.dispatch('shop/fetchTags', this.shopId).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="sass">
.container
  margin-top: 20px;

  .specs-wrapper
    padding-left: 10px;

  .specs-item
    border: 1px solid transparent;
    border-radius: 3px;
    padding: 20px;
    padding-bottom: 0;
    margin: 10px;
    background: rgb(238, 246, 245);
    position: relative;

  .delete-option
    padding-left: 40px;

  .delete-item
    position: absolute;
    right: -15px;
    top: 50px;
    font-size: 30px;
    color: red;
    background: white;
    border-radius: 50%;
    box-shadow: 0 0 10px grey;

  .delete-item:hover
    box-shadow: 0 0 20px grey;
</style>



// WEBPACK FOOTER //
// goods-edit.vue?764b5501